<div class="common-table-style">
  <div class="header-box">
    <div class="d-flex align-items-center heading-box">
      <ng-icon name="heroBellAlert"></ng-icon>
      <h2>Notification</h2>
    </div>
    <div class="d-flex justify-content-between align-items-center col-md-6 p-0">
      <div class="dense-4 search-and-filter">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Search Notification</mat-label>
          <input matInput (keyup)="applyFilter($event.target.value)" autocomplete="off">
          <mat-icon matSuffix><ng-icon name="heroMagnifyingGlass"></ng-icon></mat-icon>
        </mat-form-field>
      </div>
      <button color="accent" mat-raised-button [disabled]="!userService.permissionsValue['_USER_MANAGEMENT_ADD_']"
      [routerLink]="['/app/notification/add']">
      Add Notification </button>
    </div>
  </div>
  <div class="inner-box">
    <mat-table [dataSource]="dataSource" matSort (matSortChange)="customSortData($event)">
      <ng-container matColumnDef="Notification Name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button color="accent" disableRipple [routerLink]="['/app/notification/view', element.notificationId]"
            matTooltip="View Notification {{element.notificationName | titlecase}}" [matTooltipShowDelay]="300"
            [matTooltipHideDelay]="100">
            {{ element.notificationName | titlecase }}
          </a>
        </mat-cell>
      </ng-container>

      <!-- <ng-container matColumnDef="Type">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Type</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.notificationType }}</mat-cell>
      </ng-container> -->

      <ng-container matColumnDef="Applied On">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Applied On</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.contractTypeName != null ? element.contractTypeName : 'All' }}</mat-cell>
      </ng-container>


      <!-- <ng-container matColumnDef="Set Up On Object">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Set Up On Object</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.type }}</mat-cell>
      </ng-container> -->

      <ng-container matColumnDef="Created By">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Created By</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.createdBy | titlecase }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="Last Updated">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Last Updated</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-progress-spinner mode="indeterminate" color="accent" diameter="30"
            *ngIf="isLoading[element.notificationId]; else loaded"></mat-progress-spinner>
          <ng-template #loaded>
            {{ element.updatedOn ? element.updatedOn : element.createdOn }}
          </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Status">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
        <mat-cell *matCellDef="let element">

          <mat-progress-spinner mode="indeterminate" color="accent" diameter="30"
            *ngIf="isLoading[element.notificationId]; else loaded"></mat-progress-spinner>
          <ng-template #loaded>
            <label class="switch">
              <input class="switch-input" type="checkbox" [checked]="element.status === true" (change)="toggleNotificationStatus(element.notificationId)">
              <div class="switch-button">
                <span class="switch-button-left">Inactive</span>
                <span class="switch-button-right">Active</span>
              </div>
            </label>
          </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Action">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Action</mat-header-cell>
        <mat-cell *matCellDef="let element" class="action">
          <a mat-button color="accent" [routerLink]="['/app/notification/edit', element.notificationId]" disableRipple matTooltip="Edit Notification {{element.notificationName | titlecase}}"
            [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">
            <ng-icon name="heroPencil"></ng-icon>
          </a>

          <a mat-button color="accent" disableRipple (click)="openDeleteConfirmation(element.notificationId)"  matTooltip="Delete Notification {{element.notificationName | titlecase}}"[matTooltipShowDelay]="300" [matTooltipHideDelay]="100"><ng-icon name="heroTrash"></ng-icon></a>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

    </mat-table>

    <ng-container *ngIf="dataSource.filter &&  dataSource.filteredData.length === 0">
      <div class="no-data">
        <h4>No Data Found</h4>
        <p>There are no notification found with <strong>'{{dataSource.filter}}'</strong></p>
      </div>
    </ng-container>

    <ng-container *ngIf="dataSource.data.length === 0">
      <div class="skeleton-box">
        <ngx-skeleton-loader [theme]="{height: '200px'}"></ngx-skeleton-loader>
      </div>
    </ng-container>

    <mat-paginator [pageSizeOptions]="[10, 30, 50]" showFirstLastButtons></mat-paginator>
  </div>
</div>